export default "__VITE_ASSET__D9xj2dMq__"